import { render, staticRenderFns } from "./broker.vue?vue&type=template&id=c46460a0&scoped=true"
import script from "./broker.vue?vue&type=script&lang=js"
export * from "./broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46460a0",
  null
  
)

export default component.exports